module.exports = __webpack_public_path__ + "img/servv-logo-black.png";